import { useEffect } from "react";

type HeadProps = { url: string; type: "css" | "js" };

export const Head = ({ url, type }: HeadProps) => {
    useEffect(() => {
        // Check if the resource is already present in the DOM
        const isResourceAlreadyAdded =
            type === "css"
                ? document.querySelector(`link[href="${url}"]`)
                : document.querySelector(`script[src="${url}"]`);

        // If the resource is not already added, create and append it
        if (!isResourceAlreadyAdded) {
            // Create a <link> element for CSS or a <script> element for JavaScript
            //   let element = type === 'css' ? document.createElement('link') : document.createElement('script');
            if (type === "css") {
                const element = document.createElement("link");
                element.rel = "stylesheet";
                element.type = "text/css";
                element.href = url;
                document.head.appendChild(element);
            } else {
                const element = document.createElement("script");
                element.type = "text/javascript";
                element.src = url;
                document.head.appendChild(element);
            }
        }

        // Clean up the element when the component is unmounted
        return () => {
            // This part is the same as in the previous version
            const elementToRemove =
                type === "css"
                    ? document.querySelector(`link[href="${url}"]`)
                    : document.querySelector(`script[src="${url}"]`);
            if (elementToRemove) {
                document.head.removeChild(elementToRemove);
            }
        };
    }, [url, type]);

    return null; // This component doesn't render any visible content
};
